// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-editor-survey_form__surveyFloating {\n  position: absolute;\n  bottom: 16px;\n  left: 16px;\n}\n", "",{"version":3,"sources":["webpack://./src/editor/survey_form.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ","sourcesContent":[".surveyFloating {\n  position: absolute;\n  bottom: 16px;\n  left: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"surveyFloating": "src-editor-survey_form__surveyFloating"
};
export default ___CSS_LOADER_EXPORT___;
